import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from "rxjs/Observable";

import { AuthenticationService } from './authentication.service';
import {NotificationsService} from "angular2-notifications";

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router, private notificationService: NotificationsService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // let url: string = state.url;

    // let timer = Observable.timer(2000, 1000);
    // timer.subscribe(() => {
    //   console.log('fromrouter:', this.authenticationService.isUserLoggedIn);
    // });

    return this.authenticationService.initSite()
      .map(res => {
        if (typeof res.data.user !== 'undefined') {
          return true;
        }
        this.router.navigate(['/']);
        this.notificationService.error('Error', 'Please login first');        
        return false;
      }, err => {
        console.log(err);
      });

  }

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/auth-guard.service.ts